import { useQuery } from '@tanstack/react-query';
import { startOfDay, subDays } from 'date-fns';
import { findConversations } from './api';
import { FindHistoryRequest } from './api.types';

export const useChatbotHistory = () => {
  const request: FindHistoryRequest = {
    from: subDays(startOfDay(Date.now()), 7).toISOString(),
    max_count: 100,
    history_type: 'full',
    reference_type: 'pages',
  };

  const { data, isLoading } = useQuery({
    queryKey: ['chatbot', 'history', request],
    queryFn: () => findConversations(request),
  });

  const history = data ?? [];
  const hasHistory = history.length > 0;

  return { history, hasHistory, isLoading };
};
